import {gql} from 'apollo-angular';

export const ROOKIEDAY_REGISTER_COMPANY = gql`
  mutation rookiedayRegisterCompany($companyData: InRookieDayRegisterCompany!) {
    rookiedayRegisterCompany(companyData: $companyData) {
      type
      message
    }
  }
`;
